import { Typography } from "@mui/material";
import { Container } from "@mui/system";
import Grid from "@mui/material/Grid";
import React from "react";
import RegisterVolunteer from "./registerVolunteer";
import RegisterBulkVolunteer from "./registerBulkVolunteers";
import ComponentDivider from "../../components/componentDivider";
import { volunteerEventMockData } from "../../helpers/volunteerListMockData";
import ListofVolunteers from "./volunteersLists";
import EventCertificateGenerate from "./generateCertificate";
import { toast } from "react-toastify";

const ManageVolunteers = () => {
  const apiValidateUser = async (shortId: string): Promise<string> => {
    return "";
  };

  const apiValidateEvent = async (eventId: string): Promise<string> => {
    return "";
  };
  const showToast = (type: "success" | "error" | "info", message: string) => {
    toast[type](message);
  };

  return (
    <React.Fragment>
      <Container maxWidth="lg">
        <Typography mt={4} variant="h3">
          Manage Volunteers
        </Typography>
        <Grid
          sx={{
            border: "1px solid #E5E7EB",
            borderRadius: 1,
          }}
          size={{}}
          mt={4}
          bgcolor={"#F9FAFB"}
        >
          <Typography pb={2} pr={2} pt={2} pl={4} variant="h5">
            Register Volunteer
          </Typography>
          <RegisterVolunteer
            onToast={showToast}
            onValidateShortId={apiValidateUser}
            onValidateEvent={apiValidateEvent}
          />
        </Grid>
        <ComponentDivider text="Or" my={3} />
        <Grid
          sx={{
            border: "1px solid #E5E7EB",
            borderRadius: 1,
            fontFamily: "mcregular !important",
          }}
          size={{}}
          mt={3}
          mb={4}
          bgcolor={"#F9FAFB"}
        >
          <Typography pb={2} pr={2} pt={2} pl={4} variant="h5">
            Register Bulk Volunteers{" "}
            <Typography component="span" variant="body2" color="text.secondary">
              (Import only excel sheet which contains Email Id, Transport and Location columns.)
            </Typography>
          </Typography>
          <RegisterBulkVolunteer
            onToast={showToast}
            allUserData={volunteerEventMockData}
            onValidateShortId={apiValidateUser}
            onValidateEvent={apiValidateEvent}
          />
        </Grid>
        <ListofVolunteers
          onToast={showToast}
          allUserData={volunteerEventMockData}
          eventData={null}
          onEventHoursUpdate={null}
        />
        <br></br>
        <EventCertificateGenerate
          onToast={showToast}
          allUserData={volunteerEventMockData}
        />
        <br></br>
      </Container>
    </React.Fragment>
  );
};

export default ManageVolunteers;
